module.exports = __webpack_public_path__ + "static/img/banner-home.4598cc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logistics/banner-home.png
// module id = QT3U
// module chunks = 44